import { FORM_SCHEMA } from '../actionTypes'

const init = { data: [], current: null, loading: false, error: null }

export default function formSchemasReducer(state = init, action) {
  switch (action.type) {
    case FORM_SCHEMA.LIST_REQUEST:
      return { ...state, loading: true, error: null }
    case FORM_SCHEMA.LIST_SUCCESS:
      return { ...state, loading: false, data: action.data, error: null }
    case FORM_SCHEMA.LIST_FAILURE:
      return { ...state, loading: false, error: action.error }
    case FORM_SCHEMA.GET_ONE_REQUEST:
      return { ...state, loading: true, error: null }
    case FORM_SCHEMA.GET_ONE_SUCCESS:
      return { ...state, loading: false, current: action.data, error: null }
    case FORM_SCHEMA.GET_ONE_FAILURE:
      return { ...state, loading: false, error: action.error }
    case FORM_SCHEMA.CREATE_REQUEST:
    case FORM_SCHEMA.UPDATE_REQUEST:
    case FORM_SCHEMA.DELETE_REQUEST:
      return { ...state, loading: true, error: null }
    case FORM_SCHEMA.CREATE_SUCCESS:
      return { ...state, loading: false, data: [action.data, ...state.data], error: null }
    case FORM_SCHEMA.UPDATE_SUCCESS:
      return { ...state, loading: false, data: state.data.map((d) => (String(d.id) === String(action.data?.id) || String(d.uuid) === String(action.data?.uuid) ? action.data : d)), error: null }
    case FORM_SCHEMA.DELETE_SUCCESS:
      return { ...state, loading: false, data: state.data.filter((d) => String(d.id) !== String(action.id) && String(d.uuid) !== String(action.id)), error: null }
    case FORM_SCHEMA.CREATE_FAILURE:
    case FORM_SCHEMA.UPDATE_FAILURE:
    case FORM_SCHEMA.DELETE_FAILURE:
      return { ...state, loading: false, error: action.error }
    case FORM_SCHEMA.CLEAR:
      return init
    default:
      return state
  }
}
